export default __webpack_public_path__ + "760896f767064d1c8d1bc839396debbe.png";